// extracted by mini-css-extract-plugin
export default {"modal":"SelectDevices_modal__tdju1","tips":"SelectDevices_tips__rBQjo"};